// src/firebase.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore, doc, getDoc, setDoc, collection, getDocs, updateDoc, addDoc, query, where, deleteDoc, serverTimestamp, onSnapshot } from "firebase/firestore";
import { getAuth, GoogleAuthProvider, signInWithEmailAndPassword, signOut, signInWithPopup, fetchSignInMethodsForEmail } from "firebase/auth";
// <<< CAMBIO: Importa las funciones de Storage que necesitas aquí >>>
import { getStorage, ref, uploadBytes, getMetadata } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { firebaseConfig } from "./config/firebase.generated";

// Ensure Firebase initializes only once and only in the browser
let app;
let auth;
let db;
let storage;
let functions;

if (typeof window !== "undefined") {
  app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
  auth = getAuth(app);
  db = getFirestore(app);
  storage = getStorage(app);
  functions = getFunctions(app, 'us-central1');
}

const googleProvider = app ? new GoogleAuthProvider() : null;

// <<< CAMBIO: Exporta las funciones de Storage junto con todo lo demás >>>
export {
  app,
  auth,
  db,
  storage,
  functions,
  ref, // <--- AÑADIDO
  uploadBytes, // <--- AÑADIDO
  getMetadata, // <--- AÑADIDO (para la prueba de diagnóstico)
  googleProvider,
  signInWithEmailAndPassword,
  signOut,
  signInWithPopup,
  fetchSignInMethodsForEmail,
  doc,
  getDoc,
  setDoc,
  collection,
  getDocs,
  updateDoc,
  addDoc,
  query,
  where,
  deleteDoc,
  serverTimestamp,
  onSnapshot
};
